import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { TokenService } from '../token/token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanLoad, CanActivate {

  constructor(
    private router: Router,
    private tokenServe: TokenService
  ) { }

  private async handlePage(): Promise<boolean> {
    const isLoggedIn = await this.tokenServe.isLoggedIn();
    if (isLoggedIn) {
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    return this.handlePage();
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Promise<boolean> {
    return this.handlePage();
  }
}
